import 'selectize';

export default function initSelectize () {
  $('.devise select').selectize({
    create: false
  });
}



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/users/selectize.js